import React from 'react';

function PersonaCard(props) {

    const { persona } = props;

    console.log('persona pr', persona);

    return (
        <div className='persona-card-container'>
            <img className='photo' src='' />
            <div className='nombre'>{persona.personadesc}</div>
            <div className='tipo-persona'>{persona.tipo_personadesc}</div>
        </div>
    );
}

export default PersonaCard;